<template>
  <svg width="18" height="18" viewBox="0 0 18 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip-icon-attach)">
      <path
          d="M16.3146 2.16453C14.0712 -0.0789317 10.4207 -0.0789317 8.17701 2.16453L1.20172 9.13978C-0.400663 10.7423 -0.400557 13.3498 1.20194 14.9523C2.00325 15.7536 3.05548 16.1543 4.10813 16.1542C5.16049 16.154 6.21328 15.7535 7.01446 14.9523L13.4083 8.55833C13.8741 8.09258 14.1306 7.4733 14.1307 6.81461C14.1307 6.15589 13.8743 5.53665 13.4084 5.07076C12.4468 4.10927 10.8822 4.1093 9.92079 5.07093L5.73948 9.25214C5.41847 9.57311 5.41847 10.0936 5.73941 10.4146C6.06039 10.7357 6.58088 10.7356 6.90192 10.4146L11.0833 6.23341C11.4038 5.91289 11.9252 5.91282 12.2458 6.23334C12.401 6.38859 12.4866 6.59503 12.4866 6.81458C12.4866 7.03413 12.4011 7.2405 12.2458 7.39582L5.85195 13.7898C4.89039 14.7512 3.32593 14.7513 2.36445 13.7898C1.40296 12.8283 1.40289 11.2637 2.36427 10.3022L9.33952 3.32704C10.9422 1.72448 13.5497 1.72448 15.152 3.32704C15.9284 4.10329 16.356 5.13544 16.356 6.23327C16.356 7.33109 15.9284 8.36325 15.152 9.13957L8.1769 16.1149C7.85592 16.4359 7.85592 16.9564 8.17697 17.2774C8.33749 17.438 8.54787 17.5182 8.75821 17.5182C8.96858 17.5182 9.17896 17.4379 9.33948 17.2774L16.3145 10.3021C17.4014 9.21533 17.9999 7.77034 18 6.2333C18 4.69631 17.4014 3.25132 16.3146 2.16453Z"/>
    </g>
    <defs>
      <clipPath id="clip-icon-attach">
        <rect width="18" height="18" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: "IconAttach"
}
</script>